module.exports = __webpack_public_path__ + "img/joshuahoy_formal.87d1a0e0.jpg";